import { useState } from 'react';

import type { Aggregator } from '~/api/types';
import { isURL, isUriSafe } from '~/lib/validation';
import { TextField } from './TextField';

interface AggregatorConfigProps {
  name: string;
  aggregator: Aggregator;
  onChange: (aggregator: Aggregator) => void;
}

type FieldKey = 'endpoint' | 'identifier' | 'key';

const validators: Record<FieldKey, (value: string) => boolean> = {
  endpoint: (value) => Boolean(value) && isURL(value),
  identifier: (value) => Boolean(value) && isUriSafe(value),
  key: (value) => Boolean(value) && isUriSafe(value),
};

const labels: Record<FieldKey, string> = {
  endpoint: 'Endpoint',
  identifier: 'Identifier',
  key: 'Key',
};

const ids: Record<FieldKey, string> = {
  endpoint: 'endpoint',
  identifier: 'merchant-identifier',
  key: 'merchant-key',
};

export function AggregatorConfig({
  name,
  aggregator,
  onChange,
}: AggregatorConfigProps) {
  const [invalid, setInvalid] = useState<Record<FieldKey, boolean>>({
    endpoint: false,
    identifier: false,
    key: false,
  });

  const validateOnBlur = (field: FieldKey) => () => {
    setInvalid((current) => ({
      ...current,
      [field]: !validators[field](aggregator[field]),
    }));
  };

  return (
    <div className="flex w-full flex-col gap-4">
      {(Object.keys(labels) as FieldKey[]).map((field) => (
        <TextField
          key={field}
          id={`${name}-${ids[field]}`}
          label={`${labels[field]}${invalid[field] ? ' INVALID FORMAT' : ''}`}
          state={invalid[field] ? 'warning' : 'default'}
          value={aggregator[field]}
          onChange={(value) => onChange({ ...aggregator, [field]: value })}
          onBlur={validateOnBlur(field)}
        />
      ))}
    </div>
  );
}
